<template>
  <div v-if="accounts">
    <div @click="ToggleAccountSwitcher" @keyup.enter="ToggleAccountSwitcher" class="account-profile-button" tabindex="0">
      <div class="gds-flex-container gds-flex-container--space-between">
        <div v-if="currentAccount" class="gds-flex-container">
          <div v-if="currentAccount.photoUrl" :style="{backgroundImage: 'url(' + GetResizedAccountPhoto(currentAccount.photoUrl) + ')'}" class="small-round-img"></div>
          <div class="account-switcher__nickname gds-font-size-l gds-font-demi">{{currentAccount | accountName}}</div>
        </div>
        <div v-if="!currentAccount" class="gds-flex-container">
          <div style="backgroundImage: url(/wp-content/themes/gmptwentynineteen/assets/images/default-account.png)" class="small-round-img"></div>
          <div class="gds-font-size-l gds-font-demi">No account selected</div>
        </div>
        <div class="account-profile-button__faux-switch-btn gds-button gds-secondary gds-round">Switch</div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetResizedAccountPhoto } from "../utilities";

export default {
  name: "WidgetAccountSwitcher",
  data() {
    return {
      GetResizedAccountPhoto
    };
  },
  computed: {
    accounts() {
      return this.$store.state.user.accounts;
    },
    currentAccount() {
      return this.$store.state.user.currentAccount;
    },
  },
  methods: {
    ToggleAccountSwitcher() {
      this.$store.commit("toggleAccountSwitcher");
      // This prevents the page from scrolling down to where it was previously.
      if ('scrollRestoration' in history) {
          history.scrollRestoration = 'manual';
      }
      // This is needed if the user scrolls down during page load and you want to make sure the page is scrolled to the top once it's fully loaded.Cross-browser supported.
      window.scrollTo(0,0);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>